'use client';
import { useRouter } from 'next/navigation';

import Button from '@/components/@base/button';
import { VARIANT_ENUM } from '@/components/@base/button/type';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';

import { DATA_CY_LOGIN_BUTTON } from '@/constant/cypress';
import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

export default function LoginButton() {
  const { push } = useRouter();
  const {
    content: { aboutUs: aboutUsLocalization },
  } = pageLevelLocalization;

  return (
    <Button
      data-cy={DATA_CY_LOGIN_BUTTON}
      variant={VARIANT_ENUM.GREY}
      className='mx-4 bg-[#f7f8f91f] md:mx-20'
      onClick={() => push('/')}
    >
      <XImage
        src={imagesList.icons.zhaketFavIcon}
        alt='logo'
        height={16}
        width={16}
        className=''
      />
      <Text className='mr-2 text-[15px] leading-6 font-[200] tracking-tighter whitespace-nowrap text-[#F9FAFC]'>
        {aboutUsLocalization.login_to_zhakhet}
      </Text>
    </Button>
  );
}
